<template>
  <b-modal
    id="modal-activity"
    :visible="showModal"
    centered
    hide-footer
    :title="getModalTitle"
    @hide="resetModal"
  >
    <b-overlay :show="loading">
      <form @submit.prevent="handleValidate">
        <!-- schedule type: lesson -->
        <template v-if="isLesson">
          <basic-select
            label="Loại bài học"
            placeholder="--- Chọn loại bài học ---"
            :options="lessonTypes"
            value-label="text"
            track-by="value"
            changeValueByObject
            :value.sync="form.type"
            @update:value="filterLesson"
          />
          <basic-select
            label="Chủ đề"
            placeholder="--- Chọn chủ đề ---"
            :options="moduleList"
            value-label="text"
            track-by="value"
            changeValueByObject
            :value.sync="form.module"
            @update:value="filterLesson"
          />
          <basic-select
            label="Cấp độ"
            placeholder="--- Chọn cấp độ ---"
            :options="levelList"
            value-label="text"
            track-by="value"
            changeValueByObject
            :value.sync="form.level"
            @update:value="filterLesson"
          />
          <basic-select
            label="Bài học"
            placeholder="--- Chọn bài học ---"
            :options="lessonList"
            value-label="name"
            track-by="id"
            changeValueByObject
            required
            name="lesson"
            v-validate="'required'"
            :state="validateState('lesson')"
            :invalidFeedback="errors.first('lesson')"
            data-vv-as="Bài học"
            :value.sync="form.lesson"
          />
        </template>

        <!-- schedule type: common -->
        <template v-if="isCommonActivity">
          <basic-select
            label="Chọn loại hoạt động"
            placeholder="--- Chọn loại hoạt động ---"
            :options="activityTypes"
            value-label="text"
            track-by="value"
            changeValueByObject
            :value.sync="form.activityType"
            :allow-empty="false"
          />
          <basic-select
            v-if="isInteractionGroup"
            label="Chọn tên Hoạt động"
            placeholder="--- Chọn tên Hoạt động ---"
            :options="activities"
            value-label="text"
            track-by="value"
            changeValueByObject
            :value.sync="form.activity"
            :allow-empty="false"
            required
            name="activity"
            v-validate="'required'"
            :state="validateState('activity')"
            :invalidFeedback="errors.first('activity')"
            data-vv-as="Tên Hoạt động"
            @input="$validator.reset({ name: 'activity' })"
          />
          <basic-select
            v-if="isSurveyType"
            label="Chọn khảo sát"
            placeholder="--- Chọn khảo sát ---"
            :options="surveyList"
            value-label="text"
            track-by="value"
            changeValueByObject
            required
            name="survey"
            v-validate="'required'"
            :state="validateState('survey')"
            :invalidFeedback="errors.first('survey')"
            data-vv-as="Khảo sát"
            :value.sync="form.survey"
          />
          <!-- Bài học: dùng lại đúng bộ lọc của loại lộ trình bài học.
               Phải là v-else-if để nối tiếp chuỗi của khảo sát, dùng v-if sẽ mở
               chuỗi mới và làm ô "Tên buổi" hiện chung với ô khảo sát. -->
          <template v-else-if="isLessonClassify">
            <b-row>
              <b-col cols="6">
                <basic-select
                  label="Loại bài học"
                  placeholder="--- Chọn loại bài học ---"
                  :options="lessonTypes"
                  value-label="text"
                  track-by="value"
                  changeValueByObject
                  :value.sync="form.type"
                  @update:value="onLessonFilterChange"
                />
              </b-col>
              <b-col cols="6">
                <basic-select
                  label="Chủ đề"
                  placeholder="--- Chọn chủ đề ---"
                  :options="moduleList"
                  value-label="text"
                  track-by="value"
                  changeValueByObject
                  :value.sync="form.module"
                  @update:value="onLessonFilterChange"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <basic-select
                  label="Cấp độ"
                  placeholder="--- Chọn cấp độ ---"
                  :options="levelList"
                  value-label="text"
                  track-by="value"
                  changeValueByObject
                  :value.sync="form.level"
                  @update:value="onLessonFilterChange"
                />
              </b-col>
              <b-col cols="6">
                <basic-select
                  label="Bài học"
                  placeholder="--- Chọn bài học ---"
                  :options="lessonOptions"
                  value-label="name"
                  track-by="id"
                  changeValueByObject
                  required
                  name="lessonPick"
                  v-validate="'required'"
                  :state="validateState('lessonPick')"
                  :invalidFeedback="errors.first('lessonPick')"
                  data-vv-as="Bài học"
                  :value.sync="form.lesson"
                />
              </b-col>
            </b-row>

            <b-row v-if="isCreate">
              <b-col cols="6">
                <basic-select
                  label="Tuần"
                  placeholder="--- Chọn tuần ---"
                  :options="lessonWeekOptions"
                  value-label="text"
                  track-by="value"
                  changeValueByObject
                  required
                  name="lessonWeek"
                  v-validate="'required'"
                  :state="validateState('lessonWeek')"
                  :invalidFeedback="errors.first('lessonWeek')"
                  data-vv-as="Tuần"
                  :value.sync="form.lessonWeek"
                />
              </b-col>
            </b-row>

            <!-- Loại Bài học chỉ gán cho khách đang dùng gói, không ghi vào lộ trình -->
            <b-row v-if="isCreate">
              <b-col cols="12">
                <!-- Khoá và luôn tick: loại Bài học chỉ có một cách áp dụng -->
                <b-form-checkbox :checked="true" disabled>
                  Áp dụng cho khách hàng hiện tại
                  <small class="text-muted d-block">
                    Thêm vào lịch của khách đang kích hoạt gói và còn hạn, xuất
                    hiện hôm nay.
                    <strong>Không lưu vào lộ trình</strong> — khách kích hoạt
                    sau này sẽ không có bài học này.
                  </small>
                </b-form-checkbox>
              </b-col>

              <b-col cols="12">
                <b-alert
                  :show="previewLoading"
                  variant="secondary"
                  class="mt-3 mb-0"
                >
                  <b-spinner small class="mr-2"></b-spinner>
                  Đang kiểm tra số khách hàng bị ảnh hưởng...
                </b-alert>

                <b-alert
                  :show="!previewLoading && !canPreviewAssign"
                  variant="secondary"
                  class="mt-3 mb-0"
                >
                  Chọn bài học để xem sẽ áp dụng cho bao nhiêu khách hàng.
                </b-alert>

                <b-alert
                  v-if="!previewLoading && assignPreview"
                  :variant="assignPreview.willCreate ? 'warning' : 'secondary'"
                  show
                  class="mt-3 mb-0"
                >
                  <div class="d-flex align-items-baseline">
                    <span class="h3 mb-0 mr-2">
                      {{ assignPreview.willCreate }}
                    </span>
                    <span>khách hàng sẽ được thêm bài học này vào lịch</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
          </template>
          <template v-else-if="!isOutputRating && !isUpdateProfile">
            <basic-input
              :label="isWebinar ? 'Tên buổi webinar' : 'Tên buổi coach'"
              :placeholder="isWebinar ? 'Nhập tên buổi webinar' : 'Nhập tên buổi coach'"
              :value.sync="form.name"
              maxlength="40"
              required
              name="name"
              v-validate="'required|max:40'"
              :state="validateState('name')"
              :invalidFeedback="errors.first('name')"
              :data-vv-as="isWebinar ? 'Tên buổi webinar' : 'Tên buổi coach'"
            />
            <basic-input
              v-if="isWebinar"
              label="Link Zoom webinar"
              placeholder="Nhập link Zoom webinar"
              :value.sync="form.meetingLink"
              required
              name="meetingLink"
              v-validate="'required|url'"
              :state="validateState('meetingLink')"
              :invalidFeedback="errors.first('meetingLink')"
              data-vv-as="Link Zoom webinar"
            />
            <b-alert
              v-if="isWebinar"
              :show="hasRLink"
              variant="warning"
              class="py-2 mb-2"
            >
              Link đang chứa <strong>r.link</strong>. Đổi thành
              <strong>app.diab.com.vn</strong> mới mở phòng Zoom in app được.
            </b-alert>
            <b-row v-if="isWebinar">
              <b-col cols="6">
                <b-form-group
                  label="Ngày diễn ra"
                  label-for="meetingDay-ID"
                  class="required"
                >
                  <b-form-select
                    id="meetingDay-ID"
                    v-model="form.meetingDay"
                    :options="meetingDayOptions"
                  />
                  <small class="text-muted">
                    Ngày thứ mấy trong tuần {{ agenda ? agenda.value : '' }}
                  </small>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Giờ diễn ra"
                  label-for="meetingTime-ID"
                  :invalid-feedback="errors.first('meetingTime')"
                  :state="validateState('meetingTime')"
                  class="required"
                >
                  <b-form-input
                    id="meetingTime-ID"
                    type="time"
                    v-model="form.meetingTime"
                    name="meetingTime"
                    v-validate="'required'"
                    data-vv-as="Giờ diễn ra"
                    :state="validateState('meetingTime')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </template>

        <!-- schedule type: free -->
        <template v-if="isFreeActivity">
          <basic-input
            label="Tên hoạt động"
            placeholder="Nhập tên hoạt động"
            required
            name="name"
            v-validate="'required|max:24'"
            :state="validateState('name')"
            :invalidFeedback="errors.first('name')"
            data-vv-as="Tên hoạt động"
            maxlength="24"
            v-model="form.name"
          />
          <basic-input
            label="Số lần trong ngày"
            placeholder="Nhập số lần trong ngày"
            input-number
            maxlength="3"
            v-model="form.timesPerDay"
            name="timesPerDay"
            v-validate="{
              required: !form.timesOfActivity,
              more_than_zero: true,
            }"
            :required="!form.timesOfActivity"
            :state="validateState('timesPerDay')"
            :invalidFeedback="errors.first('timesPerDay')"
            data-vv-as="Số lần trong ngày"
          />
          <h6 class="mb-7">Hoặc</h6>
          <basic-input
            label="Thời gian diễn ra hoạt động"
            placeholder="Nhập thời gian diễn ra hoạt động"
            input-number
            maxlength="3"
            v-model="form.timesOfActivity"
            name="timesOfActivity"
            v-validate="{
              required: !form.timesPerDay,
              more_than_zero: true,
            }"
            :required="!form.timesPerDay"
            :state="validateState('timesOfActivity')"
            :invalidFeedback="errors.first('timesOfActivity')"
            data-vv-as="Thời gian diễn ra hoạt động"
          />
          <basic-select
            label="Chọn các ngày diễn ra hoạt động"
            placeholder="--- Chọn các ngày diễn ra hoạt động ---"
            :options="days"
            multiple
            name="day"
            v-validate="'required'"
            :state="validateState('day')"
            :invalidFeedback="errors.first('day')"
            data-vv-as="Chọn các ngày diễn ra hoạt động"
            :value.sync="form.selectedDays"
            value-label="text"
            track-by="value"
            changeValueByObject
            required
          />
        </template>

        <!-- schedule type: kpi -->
        <template v-if="isKpiActivity">
          <basic-select
            label="Chọn loại hoạt động"
            placeholder="--- Chọn loại hoạt động ---"
            :options="activityTypes"
            value-label="text"
            track-by="value"
            changeValueByObject
            :value.sync="form.activityType"
            :allow-empty="false"
            name="activityType"
            v-validate="'required'"
            :state="validateState('activityType')"
            :invalidFeedback="errors.first('activityType')"
            data-vv-as="Chọn loại hoạt động"
            required
            @update:value="$validator.reset()"
          />
          <template v-if="isMovementType">
            <basic-input
              label="Số lần trong ngày"
              placeholder="Nhập số lần trong ngày"
              input-number
              maxlength="3"
              v-model="form.timesPerDay"
              name="timesPerDay"
              v-validate="{
                required: true,
                more_than_zero: true,
              }"
              :required="true"
              :state="validateState('timesPerDay')"
              :invalidFeedback="errors.first('timesPerDay')"
              data-vv-as="Số lần trong ngày"
            />
            <basic-select
              label="Chọn các ngày diễn ra hoạt động"
              placeholder="--- Chọn các ngày diễn ra hoạt động ---"
              :options="days"
              multiple
              name="day"
              v-validate="'required'"
              :state="validateState('day')"
              :invalidFeedback="errors.first('day')"
              data-vv-as="Chọn các ngày diễn ra hoạt động"
              :value.sync="form.selectedDays"
              value-label="text"
              track-by="value"
              changeValueByObject
              required
            />
          </template>
          <div v-else>
            <basic-input
              label="Số phút vận động mỗi ngày"
              placeholder="Nhập số phút vận động mỗi ngày"
              input-number
              maxlength="3"
              v-model="form.timesOfActivity"
              name="timesOfActivity"
              v-validate="{
                required: true,
                more_than_zero: true,
              }"
              required
              :state="validateState('timesOfActivity')"
              :invalidFeedback="errors.first('timesOfActivity')"
              data-vv-as="Số phút vận động mỗi ngày"
            />
          </div>
        </template>

        <div class="text-right pt-6">
          <b-button class="btn mr-2" type="button" @click="resetModal">
            Hủy
          </b-button>
          <b-button class="btn btn-success" type="submit">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
            </span>
            Lưu
          </b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>
<script>
import { SCHEDULE_TYPES } from '@/core/plugins/constants';
import {
  AGENDA_COMMON_TYPE,
  MODAL_TYPE,
} from '../../../../core/plugins/constants';
export default {
  name: 'ModalActivity',
  props: {
    scheduleType: {
      type: Number,
      default: SCHEDULE_TYPES.COMMON,
    },
    agenda: {
      type: Object,
      default: () => {},
    },
    activityId: {
      type: String,
      default: null,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: MODAL_TYPE.CREATE,
    },
    // Số tuần của lộ trình, để chọn tuần cho loại Bài học
    totalWeeks: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      activityTypes: [],
      // Danh sách bài học nạp một lần, lọc phía client để không gọi API mỗi lần chọn
      allLessons: [],
      // Hai lựa chọn độc lập cho loại Bài học
      // Mặc định gán cho khách hiện tại, bỏ tick thì lưu vào lộ trình
      // Kết quả dryRun, hiện ngay khi tick để admin thấy phạm vi ảnh hưởng
      assignPreview: null,
      previewLoading: false,
      form: {
        name: null,

        // general
        activityType: null,
        activity: null,
        survey: null,
        meetingLink: null,
        meetingTime: null,
        // Ngày thứ mấy trong tuần (1-7). Gộp cùng meetingTime thành "d|HH:mm" khi gửi
        // lên BE để không phải thêm cột mới cho agenda_generals.
        meetingDay: 1,

        // free
        selectedDays: [],
        timesPerDay: null,
        timesOfActivity: null,

        // lesson
        type: null,
        module: null,
        level: null,
        lesson: null,
        // Tuần ghi vào week_in_agenda / week_in_package của target, mặc định tuần đang mở
        lessonWeek: this.agenda?.value != null
          ? { value: this.agenda.value, text: `Tuần ${this.agenda.value}` }
          : null,
      },
      surveyList: [],
      days: [],
      lessonTypes: [],
      moduleList: [],
      levelList: [],
      lessonList: [],
      activityDetail: {},
      activities: [],
    };
  },
  computed: {
    // Agenda là khuôn mẫu áp cho từng khách theo ngày kích hoạt riêng, nên chỉ chọn được
    // ngày TƯƠNG ĐỐI trong tuần chứ không phải một ngày cố định trên lịch.
    meetingDayOptions() {
      return [
        { value: 1, text: 'Ngày 1 trong tuần' },
        { value: 2, text: 'Ngày 2 trong tuần' },
        { value: 3, text: 'Ngày 3 trong tuần' },
        { value: 4, text: 'Ngày 4 trong tuần' },
        { value: 5, text: 'Ngày 5 trong tuần' },
        { value: 6, text: 'Ngày 6 trong tuần' },
        { value: 7, text: 'Ngày 7 trong tuần' },
      ];
    },
    getModalTitle() {
      return `${this.isCreate ? 'Thêm mới' : 'Chỉnh sửa'} ${
        this.isLesson ? 'bài học' : 'hoạt động'
      }`;
    },
    isLesson() {
      return this.scheduleType === SCHEDULE_TYPES.LESSON;
    },
    isCommonActivity() {
      return this.scheduleType === SCHEDULE_TYPES.COMMON;
    },
    isFreeActivity() {
      return this.scheduleType === SCHEDULE_TYPES.FREE;
    },
    isKpiActivity() {
      return this.scheduleType === SCHEDULE_TYPES.KPI;
    },
    isMovementType() {
      return this.isKpiActivity && this.form.activityType?.value !== 5;
    },
    isSurveyType() {
      return (
        this.isCommonActivity &&
        this.form.activityType?.value === AGENDA_COMMON_TYPE.SURVEY
      );
    },
    isOutputRating() {
      return (
        this.isCommonActivity &&
        this.form.activityType?.value === AGENDA_COMMON_TYPE.OUTPUT_RATING
      );
    },
    isUpdateProfile() {
      return (
        this.isCommonActivity &&
        this.form.activityType?.value === AGENDA_COMMON_TYPE.UPDATE_PROFILE
      );
    },
    isInteractionGroup() {
      return (
        this.isCommonActivity &&
        this.form.activityType?.value === AGENDA_COMMON_TYPE.GROUP_INTERACTION
      );
    },
    isWebinar() {
      return (
        this.isCommonActivity &&
        this.form.activityType?.value === AGENDA_COMMON_TYPE.WEBINAR
      );
    },
    lessonWeekOptions() {
      return Array.from({ length: this.totalWeeks }, (_, i) => ({
        value: i,
        text: `Tuần ${i}`,
      }));
    },
    // Đủ dữ liệu để gọi đếm hay chưa
    canPreviewAssign() {
      return !!this.form.lesson?.id;
    },
    // Lọc tại client từ allLessons. Ba trường lọc đều có sẵn trong LessonDtos.AppItem
    // nên không cần gọi lại API mỗi khi admin đổi bộ lọc.
    lessonOptions() {
      const type = this.form.type?.value;
      const module = this.form.module?.value;
      const level = this.form.level?.value;

      return this.allLessons.filter(
        (el) =>
          (!type || el.type === type) &&
          (!module || el.lessonModuleId === module) &&
          (!level || el.lessonLevelId === level),
      );
    },
    // Link convert ra thường mang r.link, app chỉ mở được app.diab.com.vn
    hasRLink() {
      return /r\.link/i.test(this.form.meetingLink || '');
    },
    // Bài học chọn từ trong nhóm hoạt động chung, khác với loại lộ trình "Bài học"
    isLessonClassify() {
      return (
        this.isCommonActivity &&
        this.form.activityType?.value === AGENDA_COMMON_TYPE.LESSON
      );
    },
    searchParams() {
      return {
        excludeAgendaId: this.agendaId,
        type: this.form.type?.value,
        lessonLevel: this.form.level?.value,
        lessonModule: this.form.module?.value,
      };
    },
    agendaId() {
      return this.$route.params.id;
    },
    isCreate() {
      return this.type === MODAL_TYPE.CREATE;
    },
  },
  watch: {
    // Chọn bài học là đếm ngay, đừng để admin phải bấm Lưu mới biết ảnh hưởng bao nhiêu người
    'form.lesson'() {
      this.refreshAssignPreview();
    },
    // Bộ lọc bài học chỉ nạp khi thật sự chọn loại Bài học, tránh gọi API thừa
    'form.activityType'(val) {
      if (val?.value !== AGENDA_COMMON_TYPE.LESSON) return;

      if (!this.lessonTypes.length) this.getPrepareLesson();
      if (!this.allLessons.length) this.preloadLessons();
    },
    'form.timesPerDay'(val) {
      val && (this.form.timesOfActivity = null);
    },
    'form.timesOfActivity'(val) {
      val && (this.form.timesPerDay = null);
    },
  },
  async created() {
    if (this.activityId) {
      await this.getActivityDetail();
    }
    await this.setupData();
  },
  methods: {
    resetModal() {
      this.$emit('reset');
    },
    async getActivityDetail() {
      try {
        this.loading = true;
        let url = `/Agenda/urlPath/${this.activityId}`;

        if (this.isFreeActivity) {
          url = url.replace('urlPath', 'Free');
        } else if (this.isKpiActivity) {
          url = url.replace('urlPath', 'Kpi');
        } else if (this.isCommonActivity) {
          url = url.replace('urlPath', 'General');
        } else {
          url = url.replace('urlPath', 'Lesson');
        }

        const { meta, data, error } = await this.$api.get(url);

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.activityDetail = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async setupData() {
      if (this.isCommonActivity) {
        await this.getPrepareGeneral();
        if (!this.isCreate) {
          this.form.activityType = this.activityTypes.find(
            (el) => el.value === this.activityDetail.classify,
          );
          this.form.name = this.activityDetail.name;

          if (this.isSurveyType) {
            this.form.survey = {
              text: this.activityDetail.survey.name,
              value: this.activityDetail.survey.id,
            };
          }
          if (this.isInteractionGroup) {
            this.form.activity = {
              text: this.activityDetail.calendarActiveName,
              value: this.activityDetail.calendarActive,
            };
          }
          if (this.isLessonClassify && this.activityDetail.lessonId) {
            // Watcher activityType có thể chưa chạy xong nên gọi thẳng ở đây
            if (!this.allLessons.length) await this.preloadLessons();

            this.form.lesson =
              this.allLessons.find(
                (el) => el.id === this.activityDetail.lessonId,
              ) ||
              // Bài học không còn trong danh sách (bị ẩn/xoá) thì vẫn hiện tên cũ
              {
                id: this.activityDetail.lessonId,
                name: this.activityDetail.lessonName,
              };

            if (!this.allLessons.some((el) => el.id === this.form.lesson.id)) {
              this.allLessons = [this.form.lesson, ...this.allLessons];
            }
          }

          if (this.isWebinar) {
            this.form.meetingLink = this.activityDetail.meetingLink;

            // Bản ghi cũ chỉ có "HH:mm" -> mặc định ngày 1, đúng hành vi trước đây
            const [day, time] = this.splitMeetingTime(
              this.activityDetail.meetingTime,
            );
            this.form.meetingDay = day;
            this.form.meetingTime = time;
          }
        }
      }
      if (this.isFreeActivity || this.isKpiActivity) {
        this.days = Array.from(
          { length: this.agenda.scheduleEndDay },
          (_, i) => {
            return {
              text: `Ngày ${i + 1}`,
              value: i + 1,
            };
          },
        );

        if (!this.isCreate) {
          this.form.name = this.activityDetail.name;
          this.activityDetail.timesPerDay &&
            (this.form.timesPerDay = this.activityDetail.timesPerDay);
          this.activityDetail.timesOfActivity &&
            (this.form.timesOfActivity = this.activityDetail.timesOfActivity);
          this.setValueSelectedDays(this.activityDetail.selectedDays);
        }
      }

      this.isKpiActivity && this.setActivityType();

      if (this.isLesson) {
        await this.getPrepareLesson();
        this.form.lesson = {
          id: this.activityDetail.lesson.id,
          name: this.activityDetail.lesson.name,
        };
      }
    },
    setActivityType(isAgendaHasOutputRating, isAgendaHasUpdateProfile) {
      if (this.isKpiActivity) {
        this.activityTypes = [
          {
            text: 'Đo huyết áp',
            value: 1,
          },
          {
            text: 'Đo cân nặng',
            value: 2,
          },
          {
            text: 'Nhập cảm xúc',
            value: 3,
          },
          {
            text: 'Cập nhật bữa ăn',
            value: 4,
          },
          {
            text: 'Vận động',
            value: 5,
          },
        ];

        if (!this.isCreate) {
          this.form.activityType = this.activityTypes.find(
            (el) => el.value === this.activityDetail.classify,
          );
          this.form.timesPerDay = this.activityDetail.timesPerDay;
        } else {
          this.form.activityType = {
            text: 'Đo huyết áp',
            value: 1,
          };
        }
      }

      if (this.isCommonActivity) {
        this.form.activityType = {
          text: 'Tương tác CÁ NHÂN',
          value: AGENDA_COMMON_TYPE.PERSONAL_INTERACTION,
        };
        this.activityTypes = [
          {
            text: 'Tương tác CÁ NHÂN',
            value: AGENDA_COMMON_TYPE.PERSONAL_INTERACTION,
          },
          {
            text: 'Tương tác NHÓM',
            value: AGENDA_COMMON_TYPE.GROUP_INTERACTION,
          },
          {
            text: 'Khảo sát',
            value: AGENDA_COMMON_TYPE.SURVEY,
          },
          {
            text: 'Đánh giá đầu ra',
            value: AGENDA_COMMON_TYPE.OUTPUT_RATING,
          },
          {
            text: 'Cập nhật hồ sơ',
            value: AGENDA_COMMON_TYPE.UPDATE_PROFILE,
          },
             {
            text: 'Booking Phỏng Vấn Đầu Vào',
            value: AGENDA_COMMON_TYPE.ONBOARDING_BOOKING_PVDV,
          },
             {
            text: 'Booking Phỏng Vấn Đầu Ra',
            value: AGENDA_COMMON_TYPE.ONBOARDING_BOOKING_PVDR,
          },
          {
            text: 'Webinar',
            value: AGENDA_COMMON_TYPE.WEBINAR,
          },
          {
            text: 'Bài học',
            value: AGENDA_COMMON_TYPE.LESSON,
          },

        ];

        let deleteIndex = null;

        if (isAgendaHasOutputRating) {
          deleteIndex = this.activityTypes.findIndex(
            (el) => el.value === AGENDA_COMMON_TYPE.OUTPUT_RATING,
          );
          this.activityTypes.splice(deleteIndex, 1);
        }
        if (isAgendaHasUpdateProfile) {
          deleteIndex = this.activityTypes.findIndex(
            (el) => el.value === AGENDA_COMMON_TYPE.UPDATE_PROFILE,
          );
          this.activityTypes.splice(deleteIndex, 1);
        }
      }
    },
    setValueSelectedDays(seletedDays) {
      if (seletedDays && !seletedDays.length) return [];

      seletedDays.forEach((selectedDay) => {
        this.form.selectedDays.push(
          this.days.find((el) => el.value === selectedDay),
        );
      });
    },
    async getPrepareGeneral() {
      try {
        this.loading = true;
        const { meta, data, error } = await this.$api.get(
          '/Agenda/General/PrepareFormItem',
          {
            params: {
              agendaId: this.agendaId,
            },
          },
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
        this.setActivityType(
          data.isAgendaHasOutputRating,
          data.isAgendaHasUpdateProfile,
        );
        this.surveyList = data.surveyList;
        this.activities = data.calendarActive;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async getPrepareLesson() {
      try {
        this.loading = true;
        const { meta, data, error } = await this.$api.get(
          '/Agenda/Lesson/PrepareFormItem',
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
        this.lessonTypes =
          data.typeList.map((el) => ({
            ...el,
            value: Number(el.value),
          })) || [];
        this.moduleList = data.moduleList || [];
        this.levelList = data.levelList || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    filterLesson() {
      this.form.lesson = null;
      this.searchLesson();
    },

    // Nạp một lần toàn bộ bài học đang hoạt động, sau đó lọc tại client
    async preloadLessons() {
      try {
        // Dùng endpoint rút gọn: SearchItem đi qua PrefetchRelatedData cho từng bài
        // học (N+1) nên rất chậm khi nạp toàn bộ danh sách.
        const { meta, data } = await this.$api.get(
          '/Agenda/Lesson/PickerItems',
          { params: { excludeAgendaId: this.agendaId } },
        );

        if (meta.success) {
          this.allLessons = data || [];
        }
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message || 'Không tải được danh sách bài học.',
        });
      }
    },

    // Đổi bộ lọc thì chỉ bỏ bài học đang chọn, không gọi API
    onLessonFilterChange() {
      this.form.lesson = null;
      this.assignPreview = null;
    },
    async searchLesson(loading = true) {
      if (!this.form.type && !this.form.level && !this.form.module)
        return (this.lessonList = []);

      try {
        loading && (this.loading = true);
        const { meta, data, error } = await this.$api.get(
          '/Agenda/Lesson/SearchItem',
          {
            params: this.searchParams,
          },
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
        this.lessonList = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        loading && (this.loading = false);
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    handleValidate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submit();
          return;
        }
      });
    },
    submit() {
      if (!this.isCreate) {
        if (this.isCommonActivity) return this.updateAgendaGeneral();
        if (this.isFreeActivity) return this.updateAgendaFree();
        if (this.isKpiActivity) return this.updateAgendaKpi();
        this.updateAgendaLesson();
        return;
      }

      // Bài học có thêm lựa chọn áp dụng nên đi qua điều phối riêng
      if (this.isLessonClassify) return this.submitLessonClassify();

      if (this.isCommonActivity) return this.submitGeneralOnly();

      if (this.isFreeActivity) return this.createAgendaFree();

      if (this.isKpiActivity) return this.createAgendaKpi();

      this.createAgendaLesson();
    },
    // BE lưu meetingTime dạng chuỗi nên gộp luôn ngày vào đây thay vì thêm cột:
    //   "HH:mm"    bản ghi cũ, hiểu là ngày 1 của tuần
    //   "d|HH:mm"  d = ngày thứ mấy trong tuần, 1..7
    splitMeetingTime(value) {
      const raw = (value || '').trim();
      if (!raw) return [1, null];

      const separatorIndex = raw.indexOf('|');
      if (separatorIndex <= 0) return [1, raw];

      const day = Number(raw.slice(0, separatorIndex));
      const time = raw.slice(separatorIndex + 1);

      return [Number.isInteger(day) && day >= 1 && day <= 7 ? day : 1, time];
    },
    joinMeetingTime() {
      if (!this.form.meetingTime) return null;

      const day = Number(this.form.meetingDay) || 1;
      return `${day}|${this.form.meetingTime}`;
    },
    // Payload dùng chung cho cả tạo vào lộ trình và bổ sung cho khách hiện tại
    buildGeneralPayload() {
      const payload = {
        agendaId: this.agendaId,
        classify: this.form.activityType.value,
        week: this.agenda.value,
      };

      if (this.form.activity?.value) {
        payload['calendarActivity'] = Number(this.form.activity.value);
      }

      if (this.form.survey?.value) {
        payload['surveyId'] = this.form.survey.value;
      } else if (this.isLessonClassify) {
        // Tên hiển thị lấy từ bài học, không cho nhập tay
        payload['lessonId'] = this.form.lesson?.id;
        payload['lessonWeek'] = this.form.lessonWeek?.value;
      } else if (this.form.activityType.value !== 4) {
        payload['name'] = this.form.name;
      }

      if (this.isWebinar) {
        payload['meetingLink'] = this.form.meetingLink;
        payload['meetingTime'] = this.joinMeetingTime();
      }

      return payload;
    },

    // Nhánh hoạt động chung thường: createAgendaGeneral không còn tự quản loading
    // và try/catch nữa (điều phối lo), nên cần lớp bọc này
    async submitGeneralOnly() {
      try {
        this.loading = true;
        await this.createAgendaGeneral();
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi !', msg: error.message });
      } finally {
        this.loading = false;
      }
    },

    // Trả bool để hàm điều phối biết có nên chạy bước sau hay không
    async createAgendaGeneral() {
      const { meta, error } = await this.$api.post(
        '/Agenda/General',
        this.buildGeneralPayload(),
      );

      if (!meta.success) {
        this.$toastr.e({ title: 'Lỗi !', msg: error.message });
        return false;
      }

      this.$emit('reload-data');
      return true;
    },

    // Đếm số khách sẽ bị ảnh hưởng. Trả null nếu không gọi được.
    async refreshAssignPreview() {
      if (!this.canPreviewAssign) return null;

      try {
        this.previewLoading = true;
        const { meta, data } = await this.$api.post(
          '/Agenda/General/assign-active?dryRun=true',
          this.buildGeneralPayload(),
        );

        this.assignPreview = meta.success ? data || {} : null;
        return this.assignPreview;
      } catch (error) {
        this.assignPreview = null;
        return null;
      } finally {
        this.previewLoading = false;
      }
    },

    // Điều phối hai lựa chọn của loại Bài học
    async submitLessonClassify() {
      try {
        this.loading = true;

        // Xác nhận TRƯỚC khi ghi bất cứ thứ gì
        {
          // Đếm lại ngay trước khi ghi: số liệu hiện trên alert có thể đã cũ
          const p = await this.refreshAssignPreview();

          if (!p) {
            return this.$toastr.e({
              title: 'Lỗi !',
              msg: 'Không kiểm tra được số khách hàng.',
            });
          }

          if (!p.willCreate) {
            return this.$toastr.w({
              title: 'Không có khách hàng nào phù hợp',
              msg: `Đang kích hoạt và còn hạn: ${p.totalAccounts || 0}. Bỏ qua — hết hạn: ${
                p.skippedExpired || 0
              }, ngày đã trôi qua: ${p.skippedPast || 0}, ngoài thời lượng gói: ${
                p.skippedOutOfRange || 0
              }.`,
            });
          }

          const confirmed = await this.$swal({
            title: '',
            text: `Sẽ thêm bài học này vào lịch của ${p.willCreate} khách hàng đang kích hoạt gói. Xác nhận?`,
            icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
            buttons: {
              cancel: {
                text: 'Quay lại',
                value: false,
                visible: true,
                className: 'btn btn-secondary',
                closeModal: true,
              },
              confirm: {
                text: 'Xác nhận',
                value: true,
                visible: true,
                className: 'btn btn-success',
                closeModal: true,
              },
            },
          });

          if (!confirmed) return;
        }

        // Loại Bài học chỉ gán cho khách hiện tại, không ghi vào lộ trình
        {
          const { meta, data, error } = await this.$api.post(
            '/Agenda/General/assign-active',
            this.buildGeneralPayload(),
          );

          if (!meta.success) {
            return this.$toastr.e({
              title: 'Lỗi !',
              msg: error?.message || 'Không bổ sung được cho khách hàng.',
            });
          }

          this.$toastr.s({
            title: 'Thành công !',
            msg: `Đã thêm vào lịch của ${data?.created || 0} khách hàng.`,
          });
        }

        this.$emit('reset');
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi !', msg: error.message });
      } finally {
        this.loading = false;
      }
    },
    async updateAgendaGeneral() {
      try {
        this.loading = true;
        const payload = {
          agendaId: this.agendaId,
          classify: this.form.activityType.value,
          week: this.agenda.value,
          id: this.activityDetail.id,
        };

        if (this.form.activity?.value) {
          payload['calendarActivity'] = Number(this.form.activity.value);
        }

        if (this.form.survey?.value) {
          payload['surveyId'] = this.form.survey.value;
        } else if (this.isLessonClassify) {
          payload['lessonId'] = this.form.lesson?.id;
        } else if (this.form.activityType.value !== 4) {
          payload['name'] = this.form.name;
        }

        if (this.isWebinar) {
          payload['meetingLink'] = this.form.meetingLink;
          payload['meetingTime'] = this.joinMeetingTime();
        }
        const { meta, error } = await this.$api.put(
          `/Agenda/General/${payload.id}`,
          payload,
        );
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async createAgendaFree() {
      try {
        this.loading = true;

        const payload = {
          name: this.form.name,
          agendaId: this.agendaId,
          days: this.form.selectedDays.map((el) => el.value),
        };

        if (this.form.timesPerDay) {
          payload['timesPerDay'] = Number(this.form.timesPerDay);
        }
        if (this.form.timesOfActivity) {
          payload['timesOfActivity'] = Number(this.form.timesOfActivity);
        }
        const { meta, error } = await this.$api.post('/Agenda/Free', payload);

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async updateAgendaFree() {
      try {
        this.loading = true;

        const payload = {
          name: this.form.name,
          agendaId: this.agendaId,
          days: this.form.selectedDays.map((el) => el.value),
          id: this.activityId,
        };

        if (this.form.timesPerDay) {
          payload['timesPerDay'] = Number(this.form.timesPerDay);
        }
        if (this.form.timesOfActivity) {
          payload['timesOfActivity'] = Number(this.form.timesOfActivity);
        }
        const { meta, error } = await this.$api.put(
          `/Agenda/Free/${payload.id}`,
          payload,
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async createAgendaKpi() {
      try {
        this.loading = true;

        const payload = {
          agendaId: this.agendaId,
          classify: this.form.activityType.value,
        };

        if (this.form.timesPerDay) {
          payload['timesPerDay'] = Number(this.form.timesPerDay);
        }
        if (this.form.timesOfActivity) {
          payload['timesOfActivity'] = Number(this.form.timesOfActivity);
        }
        if (this.form.selectedDays.length) {
          payload['days'] = this.form.selectedDays.map((el) => el.value);
        }

        const { meta, error } = await this.$api.post('/Agenda/Kpi', payload);

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async updateAgendaKpi() {
      try {
        this.loading = true;

        const payload = {
          agendaId: this.agendaId,
          classify: this.form.activityType.value,
          id: this.activityId,
        };

        if (this.form.timesPerDay) {
          payload['timesPerDay'] = Number(this.form.timesPerDay);
        }
        if (this.form.timesOfActivity) {
          payload['timesOfActivity'] = Number(this.form.timesOfActivity);
        }
        if (this.form.selectedDays.length) {
          payload['days'] = this.form.selectedDays.map((el) => el.value);
        }

        const { meta, error } = await this.$api.put(
          `/Agenda/Kpi/${payload.id}`,
          payload,
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async createAgendaLesson() {
      try {
        this.loading = true;

        const payload = {
          agendaId: this.agendaId,
          lessonId: this.form.lesson.id,
          week: this.agenda.value,
        };

        const { meta, error } = await this.$api.post('/Agenda/Lesson', payload);

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async updateAgendaLesson() {
      try {
        this.loading = true;

        const payload = {
          agendaId: this.agendaId,
          lessonId: this.form.lesson.id,
          week: this.agenda.value,
          id: this.activityDetail.id,
        };

        const { meta, error } = await this.$api.put(
          `/Agenda/Lesson/${payload.id}`,
          payload,
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }

        this.$emit('reload-data');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang=""></style>
